import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'model/state';
import { Dispatch } from 'redux';
import { PasswordReset } from 'components';
import { selectIsSubmitting } from 'selectors/Common';
import { selectHasErrorMessage, selectHasSuccessMessage } from 'selectors/Message';
import {resetPassword, validatePasswordResetToken} from 'actions';
import { selectIsFetching, selectResetPasswordToken } from 'selectors/Auth';
import {Credentials} from "../../model";

type SelectedValues = {
  isSubmitting: boolean,
  isValidatingToken: boolean,
  hasError: boolean,
  submittedOK: boolean,
  resetToken?: string,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  isSubmitting: selectIsSubmitting(),
  hasError: selectHasErrorMessage(),
  isValidatingToken: selectIsFetching(),
  submittedOK: selectHasSuccessMessage(),
  resetToken: selectResetPasswordToken(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  validatePasswordResetToken: (userId: string, token: string) => dispatch(validatePasswordResetToken(userId, token)),
  resetPassword: (credentials: Credentials, token: string) => dispatch(resetPassword(credentials, token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);
